const state = () => {
    return {snackbar: false, message: '', reload: false}
}

const actions = {
    alert: ({commit}, message) => {
        commit('SHOW_ALERT', message);
    },
    hide: ({commit}) => {
        commit('HIDE_ALERT');
    },
    reload: ({commit}) => {
        commit('RELOAD_MAIN');
    }
}
const getters = {
    snackbar: state => state.snackbar,
    message: state => state.message
}

const mutations = {
    SHOW_ALERT: (state, message) => {
        state.snackbar = true;
        state.message = message;
    },
    HIDE_ALERT: (state) => {
        state.snackbar = false;
        state.message ='';
    },
    RELOAD_MAIN: (state) => {
        state.reload = !state.reload;
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
